var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.4,
    height: 28,
    viewBox: "0 0 25.4 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 11.7,
    cy: 3,
    rx: 11.7,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.4,12c0,1.66-5.2,3-11.7,3S3,13.66,3,12",
    transform: "translate(-3 1.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,5V23.941C3,26.187,8.2,28,14.7,28s11.7-1.813,11.7-4.059V5",
    transform: "translate(-3 -2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbon);
export default __webpack_public_path__ + "static/media/carbon.a464cc6bd1f2b04cffb1e7996ddeb29a.svg";
export { ForwardRef as ReactComponent };